
import { types, actions } from './requests'
export const DELETECOLLECTION_TYPES = {
    ...types('DELETECOLLECTION'),
}
export const DELETECOLLECTION_ACTIONS = {
    ...actions('DELETECOLLECTION'),
}